import { c as _c } from "react/compiler-runtime";
import { TeamsTable } from "@components/table/teams/teams-table";
import { TEAMS_TABLE_COLUMNS } from "@components/table/teams/teams-table-constants";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { useMediaQueryList } from "@hooks/use-media-query";
import { TeamsMobileView } from "@pages/members/teams/teams-mobile-view";
import { MemberTeamsEmptyPage } from "@pages/profile/member-teams-empty-page";
import { useAppSelector } from "@store/store-helper";
import { memberTeamsStatusSelector } from "@store/teams/teams-selector";
/**
 * Wrapper for the member teams table that handles different views and empty states.
 * The "Remove team" action is intentionally excluded from this view.
 */
export function MemberTeamsTableWrapper(t0) {
  const $ = _c(17);
  const {
    companyId,
    sortedTeams,
    buttonComponents,
    sortBy,
    setSortBy,
    member
  } = t0;
  const status = useAppSelector(memberTeamsStatusSelector);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const shouldShowEmptyPage = sortedTeams.length === 0 && status === "succeeded" || status === "rejected";
  const isLoading = status === "pending" || status === "uninitialized";
  if (shouldShowEmptyPage) {
    let t1;
    if ($[0] !== status) {
      t1 = <MemberTeamsEmptyPage status={status} />;
      $[0] = status;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (isScreenSmOrSmaller) {
    const t1 = member ?? undefined;
    let t2;
    if ($[2] !== isLoading || $[3] !== sortBy || $[4] !== sortedTeams || $[5] !== t1) {
      t2 = <TeamsMobileView teams={sortedTeams} isLoading={isLoading} sortBy={sortBy} shouldExcludeRemove={true} shouldConfirmTeamRoleChange={true} memberToRemove={t1} />;
      $[2] = isLoading;
      $[3] = sortBy;
      $[4] = sortedTeams;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [...TEAMS_TABLE_COLUMNS];
    t2 = {
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: ["name", "users", "creationDate", "workspaceRole"]
    };
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  const t3 = member ?? undefined;
  let t4;
  if ($[9] !== buttonComponents || $[10] !== companyId || $[11] !== isLoading || $[12] !== setSortBy || $[13] !== sortBy || $[14] !== sortedTeams || $[15] !== t3) {
    t4 = <ColumnPreferencesProvider tableKey="member-teams-table" columns={t1} options={t2}><TeamsTable companyId={companyId} teams={sortedTeams} isLoading={isLoading} bulkActionButtons={buttonComponents} sortBy={sortBy} setSortBy={setSortBy} shouldExcludeRemoveFromMenu={true} shouldConfirmTeamRoleChange={true} memberToRemove={t3} /></ColumnPreferencesProvider>;
    $[9] = buttonComponents;
    $[10] = companyId;
    $[11] = isLoading;
    $[12] = setSortBy;
    $[13] = sortBy;
    $[14] = sortedTeams;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}